import axios from "axios";

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

const StudyEstEukTechMapApiService = {
    async index() {
        get_token();
        try {
            return await axios.get(
                `/study/study_est_euk_tech_map_for_commission`,
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async show_commission_details_tech_map(course_id) {
        get_token();
        try {
            return await axios.get(
                `/study/study_est_euk_tech_map_for_commission/${course_id}`,
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async show(course_id) {
        get_token();
        try {
            return await axios.get(
                `/study/study_est_euk_tech_map/${course_id}`,
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async create(data_tech_map) {
        get_token();
        try {
            return await axios.post(
                '/study/study_est_euk_tech_map',
                {
                    data_tech_map: data_tech_map
                }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async update(data_tech_map) {
        get_token();
        try {
            return await axios.put(
                '/study/study_est_euk_tech_map/:id',
                {
                    data_tech_map: data_tech_map
                }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
}

export default StudyEstEukTechMapApiService;